import { render } from "./UserPage.vue?vue&type=template&id=704197d8&scoped=true"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-704197d8"

export default script